import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="py-12 border-t border-gray-800 bg-brand-darker relative z-10" data-id="element-46">
      <div className="max-w-4xl px-4 mx-auto text-center" data-id="element-47">
        <p className="mb-6 text-gray-500" data-id="element-48">
          &copy; {new Date().getFullYear()} Ritual Anti-Procrastinación de 10
          Minutos. Todos los derechos reservados.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm" data-id="element-49">
          <button onClick={() => setActiveModal('privacy')} className="text-gray-400 transition-colors hover:text-brand-orange focus:outline-none focus:text-brand-orange" data-id="element-50">
            Política de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="text-gray-400 transition-colors hover:text-brand-orange focus:outline-none focus:text-brand-orange" data-id="element-51">
            Términos del Servicio
          </button>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-52">
        <div className="space-y-4 text-sm leading-relaxed" data-id="element-53">
          <p className="text-gray-400" data-id="element-54">
            Última actualización: {new Date().toLocaleDateString()}
          </p>

          <h3 className="text-lg font-semibold text-white mt-6 mb-2" data-id="element-55">
            1. Información que recopilamos
          </h3>
          <p data-id="element-56">
            Recopilamos información que usted nos proporciona directamente
            cuando utiliza nuestros servicios, incluyendo su nombre, dirección
            de correo electrónico, información de pago y cualquier otra
            información que decida proporcionar al adquirir nuestro ritual.
          </p>

          <h3 className="text-lg font-semibold text-white mt-6 mb-2" data-id="element-57">
            2. Uso de la información
          </h3>
          <p data-id="element-58">
            Utilizamos la información que recopilamos para proporcionar,
            mantener y mejorar nuestros servicios, procesar sus transacciones,
            enviarle confirmaciones y comunicarnos con usted sobre
            actualizaciones, soporte y ofertas relacionadas con el producto.
          </p>

          <h3 className="text-lg font-semibold text-white mt-6 mb-2" data-id="element-59">
            3. Protección de datos
          </h3>
          <p data-id="element-60">
            Implementamos medidas de seguridad técnicas y organizativas
            diseñadas para proteger su información personal contra acceso no
            autorizado, alteración, divulgación o destrucción. No vendemos ni
            compartimos su información personal con terceros para sus fines de
            marketing directo.
          </p>

          <h3 className="text-lg font-semibold text-white mt-6 mb-2" data-id="element-61">
            4. Sus derechos
          </h3>
          <p data-id="element-62">
            Usted tiene derecho a acceder, corregir o eliminar su información
            personal en cualquier momento. Si desea ejercer estos derechos, por
            favor contáctenos a través de nuestros canales de soporte.
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos del Servicio" data-id="element-63">
        <div className="space-y-4 text-sm leading-relaxed" data-id="element-64">
          <p className="text-gray-400" data-id="element-65">
            Última actualización: {new Date().toLocaleDateString()}
          </p>

          <h3 className="text-lg font-semibold text-white mt-6 mb-2" data-id="element-66">
            1. Aceptación de los términos
          </h3>
          <p data-id="element-67">
            Al acceder y utilizar este sitio web y adquirir nuestros productos
            digitales, usted acepta estar sujeto a estos Términos del Servicio y
            a todas las leyes y regulaciones aplicables. Si no está de acuerdo
            con alguno de estos términos, tiene prohibido usar o acceder a este
            sitio.
          </p>

          <h3 className="text-lg font-semibold text-white mt-6 mb-2" data-id="element-68">
            2. Licencia de uso
          </h3>
          <p data-id="element-69">
            Al adquirir el ritual, se le concede una licencia personal, no
            exclusiva e intransferible para descargar y utilizar el material
            digital únicamente para su uso personal y no comercial. Esta
            licencia no permite la reventa, distribución o modificación del
            contenido.
          </p>

          <h3 className="text-lg font-semibold text-white mt-6 mb-2" data-id="element-70">
            3. Descargo de responsabilidad
          </h3>
          <p data-id="element-71">
            Los materiales en este sitio web se proporcionan "tal cual". No
            ofrecemos garantías, expresas o implícitas, y por la presente
            renunciamos y negamos todas las demás garantías, incluyendo, sin
            limitación, garantías implícitas o condiciones de comerciabilidad,
            idoneidad para un propósito particular o no infracción de propiedad
            intelectual.
          </p>

          <h3 className="text-lg font-semibold text-white mt-6 mb-2" data-id="element-72">
            4. Política de reembolsos
          </h3>
          <p data-id="element-73">
            Debido a la naturaleza digital de nuestros productos, todas las
            ventas son finales. Sin embargo, si experimenta problemas técnicos
            para acceder a su compra, nuestro equipo de soporte le asistirá para
            garantizar que reciba el producto adquirido.
          </p>
        </div>
      </Modal>
    </footer>;
}